<template>
  <span
    class="badge badge-pill"
    :class="badgeClass"
  >
    <span class="h5">{{ score }}</span>
  </span>   
</template>

<script>

export default {
  props: {
    score: Number
  },
  computed: {
    badgeClass() {
      if (this.score < 70) {
        return 'badge-red-dark';
      }

      if (this.score < 75) {
        return 'badge-red';
      }

      if (this.score <80) {
        return 'badge-yellow';
      }

      if (this.score <= 90) {
        return 'badge-green-light';
      }

      if (this.score > 90) {
        return 'badge-green';
      }
    }
  }
}
</script>